import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-6 sm:py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Aristia Consultoria</h3>
            <p className="text-gray-300 text-sm sm:text-base">
              Transforme seus processos com consultoria especializada em qualidade, 
              auditorias e gestão documental.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Links Rápidos</h3>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white text-sm sm:text-base">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-gray-300 hover:text-white text-sm sm:text-base">
                  Serviços
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-gray-300 hover:text-white text-sm sm:text-base">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-300 hover:text-white text-sm sm:text-base">
                  Contato
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Contato</h3>
            <address className="not-italic text-gray-300 text-sm sm:text-base">
              <p>Email: contato@aristia.com.br</p>
              <p>
                Telefone: <a href="tel:+5511996666027" className="hover:text-white">(11) 9 9666-6027</a>
              </p>
            </address>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-4 sm:pt-6 text-center">
          <p className="text-gray-400 text-xs sm:text-sm">
            &copy; {new Date().getFullYear()} Aristia Consultoria. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
